// import { useState } from "react";

import Pusher from "pusher-js";
import { call, takeLatest, put } from "redux-saga/effects";

import store from "../../store";
import { pusherStart, PusherUnsbscribe } from "../../redux/support/chatsupport";
import { pusherSuccess } from "../../redux/support/chatsupport";
import config from "../../../utils/config";
import { logoutSuccess } from "../../redux/auth/authentication";
import session from "../../../utils/session";
import { showErrorMessage } from "../../redux/toast";

function connect() {
  const user = session.getSessionCred;
  try {
    const pusher = new Pusher(config.pusherAppKey, {
      cluster: config.pusherAppCluster,
      encrypted: true,
      authEndpoint: `${config.baseUrl}/user/verifyToken`,
      auth: {
        headers: {
          "access-token": user.token
        }
      }
    });

    pusher.connection.bind("error", function (error) {
      // console.error("error", error);
    });

    pusher.connection.bind("disconnected", function () {});
    return { pusher };
  } catch (error) {
    return { error };
  }
}

function* pusherWatcher() {
  yield takeLatest(
    [pusherStart.type, logoutSuccess.type, PusherUnsbscribe.type],
    Pusherworker
  );
}

function* Pusherworker(action) {
  try {
    const user = session.getSessionCred;
    if (user) {
      const { pusher } = yield call(connect);
      switch (action.type) {
        case pusherStart.type: {
          const defaultTicketid = action.payload;
          const channel = pusher.subscribe(
            `private-supportTicket.${defaultTicketid}`
          );

          const ticketStatusChannel = pusher.subscribe(
            `private-ticketStatus.${defaultTicketid}`
          );
          ticketStatusChannel.bind("status", function (data) {
            store.dispatch(pusherSuccess(data));
          });
          channel.bind("support", function (data) {
            store.dispatch(pusherSuccess(data));
          });
          break;
        }

        case logoutSuccess.type: {
          yield put(pusher.disconnect());
          break;
        }

        case PusherUnsbscribe.type: {
          const defaultTicketid = action.payload;

          pusher.unsubscribe(`private-supportTicket.${defaultTicketid}`);
          pusher.unsubscribe(`private-ticketStatus.${defaultTicketid}`);
          break;
        }

        default: {
          break;
        }
      }
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
  }
}

export default pusherWatcher;
